import ReactTooltip from 'react-tooltip';
import I18n from '../../config/i18n';
import type { ExtraServiceCondition, ExtraServiceKey } from '../../routes/reducers/types';
import { ReactComponent as ChampagneGlasses } from './extra-service-icons/champagne-glasses.svg';
import { ReactComponent as Bicycle } from './extra-service-icons/bicycle.svg';
import { ReactComponent as CarBolt } from './extra-service-icons/car-bolt.svg';
import { ReactComponent as CircleOne } from './extra-service-icons/circle-1.svg';
import { ReactComponent as Croissant } from './extra-service-icons/croissant.svg';
import { ReactComponent as Dog } from './extra-service-icons/dog.svg';
import { ReactComponent as Flower } from './extra-service-icons/flower-tulip.svg';
import { ReactComponent as PlateUtensils } from './extra-service-icons/plate-utensils.svg';
import { ReactComponent as Spa } from './extra-service-icons/spa.svg';
import { ReactComponent as Pool } from './extra-service-icons/water-ladder.svg';
import { ReactComponent as Sauna } from './extra-service-icons/heat.svg';
import { ReactComponent as Whirlpool } from './extra-service-icons/hot-tub-person.svg';

import './ExtraServiceIcon.css';

interface ExtraServiceIconProps {
  extraServiceCondition: ExtraServiceCondition;
}

function IconForService({
  extraServiceKey,
}: {
  extraServiceKey: ExtraServiceKey;
}): JSX.Element | null {
  switch (extraServiceKey) {
    case '1-night-only':
      return <CircleOne />;
    case 'bikerental':
      return <Bicycle />;
    case 'carcharger':
      return <CarBolt />;
    case 'breakfast':
      return <Croissant />;
    case 'casapilot-breakfast':
      return (
        <a href={I18n.t('shared.footer.breakfast_url')} target="_blank" rel="noreferrer">
          <Croissant />
        </a>
      );
    case 'champagne':
      return <ChampagneGlasses />;
    case 'dinner':
      return <PlateUtensils />;
    case 'dog':
      return <Dog />;
    case 'flowers':
      return <Flower />;
    case 'massage':
      return <Spa />;
    case 'pool':
      return <Pool />;
    case 'sauna':
      return <Sauna />;
    case 'whirlpool':
      return <Whirlpool />;
    default:
      return null;
  }
}

function tooltipText(extraService: ExtraServiceCondition): string | null {
  if (extraService.included_in_price) {
    return I18n.t(`extra_services.included.${extraService.extra_service_key}`);
  }

  return I18n.t(`extra_services.bookable.${extraService.extra_service_key}`);
}

export default function ExtraServiceIcon({
  extraServiceCondition,
}: ExtraServiceIconProps): JSX.Element {
  return (
    <span
      className={`extra-service-icon ${
        extraServiceCondition.included_in_price ? 'extra-service-icon--included-in-price' : ''
      }`}
      data-tip={tooltipText(extraServiceCondition)}
      data-background-color="#009ac6"
    >
      <IconForService extraServiceKey={extraServiceCondition.extra_service_key} />
      <ReactTooltip />
    </span>
  );
}
